import { faReceipt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DataGrid, { Column, Pager, Paging, SearchPanel, Summary, TotalItem } from 'devextreme-react/cjs/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import moment from 'moment';
import React, { lazy, Suspense, useCallback, useMemo, useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { getAllCustomerLedgerData } from './services/CustomerLadger.services';
import useHasPermission from 'hooks/useHasPermission';

const CustomerLedgerModal = lazy(() =>
    import('./CustomerLedgerModal')
        .then(module => ({ default: module.CustomerLedgerModal }))
);

interface CustomerData {
    id: number;
    customerId: number;
    customerName: string;
    customerEmail: string;
    customerMobileNo: string;
    customerAddress: string;
    refundableBalance: number;
}

interface SelectedCustomer {
    id: number;
    name: string;
}

const CustomerLedger: React.FC = () => {
    const [showCustomerLedgerModal, setShowCustomerLedgerModal] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState<SelectedCustomer | null>(null);
    const hasPermission = useHasPermission();


    const handleCustomerLedger = useCallback((data: CustomerData) => {
        if (!data?.customerId || !data?.customerName) {
            toast.error("Customer details are missing.");
            return;
        }

        setSelectedCustomer({
            id: data.customerId,
            name: data.customerName
        });
        setShowCustomerLedgerModal(true);
    }, []);

    const dataSource = useMemo(() => {
        return new CustomStore({
            key: 'id',
            load: async (loadOptions) => {
                try {
                    const search = JSON.parse(JSON.stringify(loadOptions));
                    const parameterList = new URLSearchParams();

                    for (const [key, value] of Object.entries(search)) {
                        parameterList.append(key, JSON.stringify(value));
                    }

                    const response = await getAllCustomerLedgerData(parameterList);
                    // return {
                    //     data: response?.data || [],
                    //     totalCount: response?.data.length || 0,
                    // };
                    return response
                } catch (error) {
                    console.error("Data loading error:", error);
                    return { data: [], totalCount: 0 };
                }
            }
        });
    }, []);

    const formatCurrency = useCallback((amount: number) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR'
        }).format(amount || 0);
    }, []);

    const handleModalClose = useCallback(() => {
        setShowCustomerLedgerModal(false);
        setSelectedCustomer(null);
    }, []);

    return (
        <React.Fragment>

            <div className="page-content">
                <div className="container-fluid">
                    <Card>
                        <Card.Header className='d-flex justify-content-between align-items-center'>
                            <h5 className='m-0'>List Of Customer Ledger</h5>
                        </Card.Header>
                        <Card.Body className="pt-0">
                            {hasPermission('Ledger.Read') &&
                                <DataGrid
                                    dataSource={dataSource}
                                    remoteOperations={{ groupPaging: true }}
                                    showRowLines={true}
                                    keyExpr="id"
                                    showBorders={true}
                                    onContentReady={(e) => {
                                        const hasData = e.component.totalCount() > 0;
                                        e.component.option("pager.visible", hasData);
                                        e.component.option("paging.visible", hasData);
                                    }}
                                >
                                    <Pager
                                        allowedPageSizes={[10, 25, 50, 100]}
                                        showPageSizeSelector={true}
                                        showNavigationButtons={true}
                                        displayMode="full"
                                        showInfo={true}
                                    />
                                    <Summary>
                                        <TotalItem
                                        // column="Sr.No."
                                        // summaryType="count"
                                        // displayFormat="Total : {0}"
                                        />
                                    </Summary>
                                    <Paging defaultPageSize={10} />
                                    <SearchPanel visible width={240} placeholder="Search..." />
                                    <Column
                                        allowFiltering={false} dataField="action"
                                        caption="Action"
                                        dataType="string"
                                        cellRender={({ data }) => (
                                            // <div className='d-flex gap-1'>
                                            //     <button
                                            //         onClick={() => handleCustomerLedger(data)}
                                            //         title="View Customer Ledger"
                                            //     >
                                            //         <FontAwesomeIcon icon={faReceipt} title="View Customer Ledger" />
                                            //     </button>
                                            // </div>



                                            <FontAwesomeIcon type='button' onClick={() => handleCustomerLedger(data)} icon={faReceipt} title="View Customer Ledger" />

                                        )}
                                    />

                                    {/* <Column
                                    caption="Sr.No."
                                    dataType="number"
                                    alignment="center"
                                    allowFiltering={false}
                                    cellRender={(e) => {
                                        const rowIndex = e.rowIndex + 1 + e.component.pageIndex() * e.component.pageSize();
                                        return <span>{rowIndex}</span>;
                                    }}
                                /> */}


                                    <Column allowFiltering={true} dataField="customerName" caption="Name" dataType="string" />
                                    <Column allowFiltering={false} dataField="customerEmail" caption="Email" dataType="string" />
                                    <Column allowFiltering={true} dataField="customerMobileNo" caption="Mobile No." dataType="string" />
                                    <Column allowFiltering={true} dataField="customerAddress" caption="Address" dataType="string" />
                                    <Column allowFiltering={false} dataField="refundableBalance" caption="Balance" dataType="string"
                                        cellRender={({ value }) => (
                                            <span>{formatCurrency(value)}</span>
                                        )}
                                    />

                                    <Column
                                        allowFiltering={false} dataField="createdOn"
                                        caption="Date"
                                        dataType="date"
                                        format="dd/MM/yyyy"
                                        sortOrder='desc'
                                    />


                                </DataGrid>}
                        </Card.Body>
                    </Card>
                </div>
            </div>

            {showCustomerLedgerModal && (
                <Suspense fallback={<div>Loading customer ledger...</div>}>
                    <CustomerLedgerModal
                        show={showCustomerLedgerModal}
                        onHide={handleModalClose}
                        customerId={selectedCustomer?.id}
                        customerName={selectedCustomer?.name}
                    />
                </Suspense>
            )}
        </React.Fragment>
    );
};

export default CustomerLedger;
